<template>
<div class="row">
    <div class="col-lg-6 col-md-6 col-sm-8 col-xs-12">
        <span class='content-box-title'>Alteração de senha</span>
        <div class="content-box">
            <form @submit.prevent='alterar_senha'>
<!--                 <div class="form-group">
                    <label>Senha atual:</label>
                    <input v-model="form.password" type="password" name="password"
                    class="form-control" :class="{ 'is-invalid': form.errors.has('password') }">
                    <has-error :form="form" field="password"></has-error>
                </div>  -->               
                <div class="form-group">
                    <label>Nova senha:</label>
                    <input v-model="form.new_password" type="password" name="new_password"
                    class="form-control" :class="{ 'is-invalid': form.errors.has('new_password') }">
                    <has-error :form="form" field="new_password"></has-error>
                </div>                  
                <div class="form-group">
                    <label>Digite novamente:</label>
                    <input v-model="form.new_password_confirmation" type="password" name="new_password_confirmation"
                    class="form-control" :class="{ 'is-invalid': form.errors.has('new_password_confirmation') }">
                    <has-error :form="form" field="new_password_confirmation"></has-error>
                </div>  
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 right">
                        <button type="button" class="btn btn-secondary" @click='cancel'>Cancelar</button>
                        <button type="submit" class="btn btn-primary">Atualizar</button>
                    </div>
                </div>                               
            </form>
        </div>
    </div>
</div>
</template>

<script>
    export default {
        data(){
            return{
                form : new Form({
                    password:"",
                    new_password:"",
                    new_password_confirmation:""
                })
            }
        },
        methods:{
            alterar_senha(){
                this.form.post('/api/apiusuarios/alterarsenha')
                    .then((data)=>{
                        Swal.fire('Senha alterada','Senha alterada com sucesso','success');
                        this.form.reset();
                    });            
            },
            cancel(){
                this.form.reset();
            }
        }
    }
</script>
